// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CandidateWelcome_page__DuVVM { min-height: 100vh; display: flex; align-items: center; justify-content: center; background: var(--gray-50); padding: 1.5rem; }
.CandidateWelcome_card__JdY17 { background: white; border: 1px solid var(--border); border-radius: var(--radius-lg); width: 100%; max-width: 900px; box-shadow: var(--shadow); overflow: hidden; }
.CandidateWelcome_topBar__PucjB { padding: 0.9rem 1.5rem; border-bottom: 1px solid var(--border); }
.CandidateWelcome_logoRow__r1nb8 { display: flex; align-items: center; gap: 0.65rem; }
.CandidateWelcome_logoMark__ZmeFm { width: 32px; height: auto; flex-shrink: 0; }
.CandidateWelcome_logoText__vLUpM { font-size: 0.75rem; color: var(--gray-700); font-weight: 500; }
.CandidateWelcome_body__gpEsF { padding: 1.5rem; }
.CandidateWelcome_greetBlock__v4DLT { margin-bottom: 1rem; }
.CandidateWelcome_greet__MQzTd { font-size: 1.4rem; color: var(--black); margin-bottom: 0.4rem; }
.CandidateWelcome_roleTag__3Itaj { display: inline-block; padding: 3px 10px; border-radius: 4px; font-size: 0.75rem; font-weight: 500; transition: all 0.2s; }
.CandidateWelcome_role_RSM__Ps41s { background: #1a5c38; color: white; }
.CandidateWelcome_role_FSM__aknPH { background: #2d8659; color: white; }
.CandidateWelcome_role_TSE__cJUJR { background: #4da878; color: white; }
.CandidateWelcome_intro__xpn\\+q { font-size: 0.82rem; color: var(--gray-700); line-height: 1.6; margin-bottom: 1.25rem; }
.CandidateWelcome_sectionGrid__6FqJd { display: grid; grid-template-columns: 1fr 1fr; gap: 1rem; margin-bottom: 1.25rem; }
.CandidateWelcome_secCard__MrWn7 { background: white; border: 1px solid var(--border); border-radius: var(--radius-lg); padding: 1.25rem; display: flex; flex-direction: column; gap: 0.85rem; transition: all 0.2s; }
.CandidateWelcome_secCard__MrWn7:hover { border-color: var(--green); box-shadow: 0 4px 12px rgba(26,92,56,0.08); }
.CandidateWelcome_secHeader__9nLFf { display: flex; align-items: center; gap: 0.75rem; }
.CandidateWelcome_secNum__9VmVZ { width: 36px; height: 36px; background: var(--green); color: white; border-radius: 50%; display: flex; align-items: center; justify-content: center; font-size: 0.95rem; font-weight: 700; flex-shrink: 0; }
.CandidateWelcome_secLabel__JA1P\\+ { font-size: 0.75rem; font-weight: 500; text-transform: uppercase; letter-spacing: 0.05em; color: var(--gray-500); }
.CandidateWelcome_secContent__3sSLD { display: flex; flex-direction: column; gap: 0.5rem; }
.CandidateWelcome_secTitle__qtl2f { font-size: 0.95rem; font-weight: 600; color: var(--gray-900); }
.CandidateWelcome_secDesc__31mTc { font-size: 0.8rem; color: var(--gray-600); line-height: 1.5; }
.CandidateWelcome_secCount__BBWyC { font-size: 0.75rem; color: var(--green); font-weight: 500; }
.CandidateWelcome_notice__xyfk2 { display: flex; gap: 0.6rem; padding: 1rem 1rem; background: #fff8f0; border-left: 4px solid #d35400; border-radius: var(--radius); margin-bottom: 1.25rem; }
.CandidateWelcome_noticeIcon__uvF2y { font-size: 1.1rem; flex-shrink: 0; margin-top: 2px; }
.CandidateWelcome_noticeContent__tihJc { display: flex; flex-direction: column; gap: 0.35rem; width: 100%; }
.CandidateWelcome_noticeTitle__WtOR- { font-size: 0.85rem; font-weight: 700; color: #d35400; }
.CandidateWelcome_noticeText__AltyL { font-size: 0.78rem; color: #c77a2e; line-height: 1.5; font-weight: 600; }
.CandidateWelcome_startBtn__VR0Kj { width: 100%; padding: 0.75rem; background: var(--red); color: white; border: none; border-radius: var(--radius); font-size: 0.875rem; font-weight: 500; transition: background 0.15s; }
.CandidateWelcome_startBtn__VR0Kj:hover { background: var(--red-dark); }
.CandidateWelcome_footer__LR9GM { padding: 0.9rem 1.5rem; text-align: center; font-size: 0.68rem; color: var(--gray-300); border-top: 1px solid var(--border); }

/* Mobile Responsive */
@media (max-width: 640px) {
  .CandidateWelcome_card__JdY17 { border-radius: var(--radius); }
  .CandidateWelcome_sectionGrid__6FqJd { grid-template-columns: 1fr; gap: 0.85rem; }
  .CandidateWelcome_secCard__MrWn7 { padding: 1rem; }
  .CandidateWelcome_secNum__9VmVZ { width: 32px; height: 32px; font-size: 0.9rem; }
  .CandidateWelcome_secTitle__qtl2f { font-size: 0.9rem; }
  .CandidateWelcome_secDesc__31mTc { font-size: 0.75rem; }
}

@media (max-width: 480px) {
  .CandidateWelcome_body__gpEsF { padding: 1.25rem 1rem; }
  .CandidateWelcome_greet__MQzTd { font-size: 1.2rem; }
  .CandidateWelcome_intro__xpn\\+q { font-size: 0.78rem; margin-bottom: 1rem; }
  .CandidateWelcome_sectionGrid__6FqJd { gap: 0.75rem; }
  .CandidateWelcome_secCard__MrWn7 { padding: 0.9rem; }
  .CandidateWelcome_secNum__9VmVZ { width: 28px; height: 28px; font-size: 0.8rem; }
  .CandidateWelcome_secLabel__JA1P\\+ { font-size: 0.7rem; }
  .CandidateWelcome_secTitle__qtl2f { font-size: 0.85rem; }
  .CandidateWelcome_secDesc__31mTc { font-size: 0.72rem; }
  .CandidateWelcome_secCount__BBWyC { font-size: 0.7rem; }
}

/* Modal Styles */
.CandidateWelcome_modalOverlay__5Foaa {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 1.5rem;
  animation: CandidateWelcome_fadeIn__BLaKZ 0.2s ease;
}

@keyframes CandidateWelcome_fadeIn__BLaKZ {
  from { opacity: 0; }
  to { opacity: 1; }
}

.CandidateWelcome_modalCard__i\\+qm8 {
  background: white;
  border-radius: var(--radius-lg);
  width: 100%;
  max-width: 800px;
  max-height: none;
  overflow-y: visible;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  animation: CandidateWelcome_slideUp__YLDSy 0.3s ease;
}

@keyframes CandidateWelcome_slideUp__YLDSy {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.CandidateWelcome_modalHeader__TEhus {
  padding: 1rem 1.25rem 0.75rem;
  border-bottom: 1px solid var(--border);
  background: linear-gradient(135deg, var(--red-light) 0%, rgba(255, 230, 225, 0.5) 100%);
}

.CandidateWelcome_modalTitle__vZXSW {
  font-size: 1rem;
  font-weight: 700;
  color: var(--red);
  margin-bottom: 0.25rem;
}

.CandidateWelcome_modalSub__IJrcT {
  font-size: 0.72rem;
  color: var(--gray-600);
}

.CandidateWelcome_modalContent__w-Go2 {
  padding: 0.85rem 1rem;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.CandidateWelcome_modalSection__ZRZWv {
  display: flex;
  gap: 0.75rem;
  padding: 0.8rem;
  background: var(--gray-50);
  border-radius: var(--radius);
  border-left: 3px solid var(--green);
}

.CandidateWelcome_modalSectionIcon__JGZru {
  font-size: 1.25rem;
  flex-shrink: 0;
  min-width: 28px;
  text-align: center;
}

.CandidateWelcome_modalSectionTitle__Bon-P {
  font-size: 0.8rem;
  font-weight: 700;
  color: var(--gray-900);
  margin-bottom: 0.25rem;
}

.CandidateWelcome_modalSectionText__56jQa {
  font-size: 0.73rem;
  color: var(--gray-700);
  line-height: 1.4;
}

.CandidateWelcome_restrictionsList__R7Wbu {
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
  margin-top: 0.3rem;
}

.CandidateWelcome_restrictionItem__9\\+hfD {
  display: flex;
  gap: 0.5rem;
  align-items: flex-start;
  font-size: 0.72rem;
  color: var(--gray-700);
  line-height: 1.3;
}

.CandidateWelcome_restrictionBullet__9Srhy {
  color: var(--red);
  font-weight: 700;
  flex-shrink: 0;
  font-size: 0.55rem;
  margin-top: 0.15rem;
}

.CandidateWelcome_modalActions__A\\+kI0 {
  padding: 0.85rem 1rem;
  border-top: 1px solid var(--border);
  display: flex;
  gap: 0.6rem;
  justify-content: flex-end;
}

.CandidateWelcome_cancelBtn__A5sVY {
  padding: 0.55rem 1.25rem;
  background: var(--gray-100);
  color: var(--gray-700);
  border: 1px solid var(--border);
  border-radius: var(--radius);
  font-size: 0.75rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
}

.CandidateWelcome_cancelBtn__A5sVY:hover {
  background: var(--gray-200);
  border-color: var(--gray-300);
}

.CandidateWelcome_confirmBtn__c1qsd {
  padding: 0.55rem 1.25rem;
  background: var(--red);
  color: white;
  border: none;
  border-radius: var(--radius);
  font-size: 0.75rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
}

.CandidateWelcome_confirmBtn__c1qsd:hover:not(:disabled) {
  background: var(--red-dark);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(220, 38, 38, 0.3);
}

.CandidateWelcome_confirmBtn__c1qsd:disabled {
  background: var(--gray-300);
  color: var(--gray-500);
  cursor: not-allowed;
  opacity: 0.6;
}

.CandidateWelcome_cameraRequestBtn__53\\+gO {
  width: 100%;
  padding: 0.55rem 1rem;
  background: var(--blue);
  color: white;
  border: none;
  border-radius: var(--radius);
  font-size: 0.75rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  margin-top: 0.5rem;
}

.CandidateWelcome_cameraRequestBtn__53\\+gO:hover:not(:disabled) {
  background: var(--blue-dark);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(37, 99, 235, 0.3);
}

.CandidateWelcome_cameraRequestBtn__53\\+gO:disabled {
  background: var(--green);
  color: white;
  cursor: default;
  opacity: 0.8;
}

.CandidateWelcome_cameraSuccessBox__lW23s {
  padding: 0.6rem 0.85rem;
  background: #f0fdf4;
  border: 1px solid #86efac;
  border-radius: var(--radius);
  color: #166534;
  font-size: 0.72rem;
  font-weight: 600;
  display: flex;
  align-items: center;
  margin-bottom: 0.5rem;
  gap: 0.5rem;
}

.CandidateWelcome_cameraErrorBox__DMB-W {
  padding: 0.6rem 0.85rem;
  background: #fef2f2;
  border: 1px solid #fecaca;
  border-radius: var(--radius);
  color: #991b1b;
  font-size: 0.72rem;
  font-weight: 600;
}

@media (max-width: 640px) {
  .CandidateWelcome_modalOverlay__5Foaa {
    padding: 1rem;
  }

  .CandidateWelcome_modalCard__i\\+qm8 {
    max-width: 100%;
    max-height: none;
  }

  .CandidateWelcome_modalHeader__TEhus {
    padding: 0.9rem 1rem 0.7rem;
  }

  .CandidateWelcome_modalTitle__vZXSW {
    font-size: 0.95rem;
  }

  .CandidateWelcome_modalContent__w-Go2 {
    padding: 0.75rem 0.9rem;
    gap: 0.65rem;
  }

  .CandidateWelcome_modalSection__ZRZWv {
    padding: 0.75rem;
    gap: 0.65rem;
  }

  .CandidateWelcome_modalSectionIcon__JGZru {
    font-size: 1.1rem;
    min-width: 24px;
  }

  .CandidateWelcome_modalSectionTitle__Bon-P {
    font-size: 0.75rem;
    margin-bottom: 0.2rem;
  }

  .CandidateWelcome_modalSectionText__56jQa {
    font-size: 0.68rem;
    line-height: 1.3;
  }

  .CandidateWelcome_restrictionsList__R7Wbu {
    gap: 0.35rem;
    margin-top: 0.25rem;
  }

  .CandidateWelcome_restrictionItem__9\\+hfD {
    font-size: 0.68rem;
    gap: 0.45rem;
    line-height: 1.2;
  }

  .CandidateWelcome_modalActions__A\\+kI0 {
    padding: 0.75rem 0.9rem;
    flex-direction: row;
    gap: 0.5rem;
  }

  .CandidateWelcome_cancelBtn__A5sVY,
  .CandidateWelcome_confirmBtn__c1qsd {
    width: auto;
    padding: 0.5rem 1rem;
    font-size: 0.7rem;
  }
}

/* Proctoring Warning Modal Styles */
.CandidateWelcome_proctoringWarningCard__danRi {
  background: white;
  border-radius: var(--radius-lg);
  width: 100%;
  max-width: 500px;
  max-height: none;
  overflow-y: visible;
  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.35);
  animation: CandidateWelcome_slideUp__YLDSy 0.3s ease;
}

.CandidateWelcome_proctoringHeader__sv105 {
  padding: 1rem 1.25rem 0.75rem;
  text-align: center;
  border-bottom: 2px solid #fee2e2;
  background: linear-gradient(135deg, #fef2f2 0%, #fff7f7 100%);
}

.CandidateWelcome_proctoringIcon__oBHKX {
  font-size: 2rem;
  display: block;
  margin-bottom: 0.25rem;
}

.CandidateWelcome_proctoringTitle__8BOsU {
  font-size: 1.1rem;
  font-weight: 800;
  color: #dc2626;
  margin: 0;
  letter-spacing: -0.5px;
}

.CandidateWelcome_proctoringContent__0UkTg {
  padding: 1rem;
  display: flex;
  flex-direction: column;
  gap: 0.85rem;
}

.CandidateWelcome_proctoringIntro__J9eAG {
  font-size: 0.8rem;
  color: var(--gray-700);
  line-height: 1.5;
  margin: 0;
  font-weight: 500;
}

.CandidateWelcome_proctoringWarnings__X6gNA {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0.65rem;
}

.CandidateWelcome_warningCard__DVIGN {
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
  padding: 0.75rem;
  background: #fafafa;
  border: 1.5px solid #f3f4f6;
  border-radius: var(--radius);
  transition: all 0.2s ease;
  text-align: center;
}

.CandidateWelcome_warningCard__DVIGN:hover {
  border-color: #dc2626;
  background: #fff5f5;
  box-shadow: 0 2px 8px rgba(220, 38, 38, 0.1);
}

.CandidateWelcome_warningIcon__ZkSuX {
  font-size: 1.4rem;
  display: block;
}

.CandidateWelcome_warningText__C9TXg {
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
}

.CandidateWelcome_warningText__C9TXg strong {
  font-size: 0.78rem;
  font-weight: 700;
  color: #1f2937;
  display: block;
}

.CandidateWelcome_warningText__C9TXg p {
  font-size: 0.7rem;
  color: var(--gray-600);
  line-height: 1.3;
  margin: 0;
}

.CandidateWelcome_proctoringAcknowledgment__E\\+LGV {
  padding: 0.75rem 0.9rem;
  background: #fef3c7;
  border-left: 3px solid #f59e0b;
  border-radius: var(--radius);
  font-size: 0.75rem;
  color: #78350f;
  line-height: 1.4;
  text-align: center;
  font-weight: 600;
}

.CandidateWelcome_proctoringActions__SRJdK {
  padding: 0.9rem 1rem;
  border-top: 1px solid var(--border);
  display: flex;
  gap: 0.6rem;
  justify-content: center;
  background: var(--gray-50);
}

.CandidateWelcome_backBtn__CwGuK {
  padding: 0.6rem 1.25rem;
  background: white;
  color: var(--gray-700);
  border: 2px solid var(--gray-300);
  border-radius: var(--radius);
  font-size: 0.78rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  min-width: 110px;
}

.CandidateWelcome_backBtn__CwGuK:hover {
  background: var(--gray-100);
  border-color: var(--gray-400);
}

.CandidateWelcome_proceedBtn__q0exL {
  padding: 0.6rem 1.25rem;
  background: #dc2626;
  color: white;
  border: none;
  border-radius: var(--radius);
  font-size: 0.78rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  min-width: 110px;
}

.CandidateWelcome_proceedBtn__q0exL:hover {
  background: #b91c1c;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(220, 38, 38, 0.25);
}

.CandidateWelcome_proceedBtn__q0exL:active {
  transform: translateY(0);
}

@media (max-width: 640px) {
  .CandidateWelcome_proctoringWarningCard__danRi {
    max-width: 100%;
    border-radius: var(--radius);
  }

  .CandidateWelcome_proctoringHeader__sv105 {
    padding: 1rem 1.25rem 0.85rem;
  }

  .CandidateWelcome_proctoringIcon__oBHKX {
    font-size: 1.8rem;
    margin-bottom: 0.3rem;
  }

  .CandidateWelcome_proctoringTitle__8BOsU {
    font-size: 1rem;
  }

  .CandidateWelcome_proctoringContent__0UkTg {
    padding: 1rem;
    gap: 0.9rem;
  }

  .CandidateWelcome_proctoringIntro__J9eAG {
    font-size: 0.8rem;
  }

  .CandidateWelcome_proctoringWarnings__X6gNA {
    grid-template-columns: 1fr;
    gap: 0.75rem;
  }

  .CandidateWelcome_warningCard__DVIGN {
    padding: 0.8rem;
  }

  .CandidateWelcome_warningIcon__ZkSuX {
    font-size: 1.4rem;
  }

  .CandidateWelcome_warningText__C9TXg strong {
    font-size: 0.78rem;
  }

  .CandidateWelcome_warningText__C9TXg p {
    font-size: 0.7rem;
  }

  .CandidateWelcome_proctoringAcknowledgment__E\\+LGV {
    padding: 0.75rem 0.9rem;
    font-size: 0.75rem;
  }

  .CandidateWelcome_proctoringActions__SRJdK {
    padding: 0.85rem 1rem;
    flex-direction: column;
    gap: 0.6rem;
  }

  .CandidateWelcome_backBtn__CwGuK,
  .CandidateWelcome_proceedBtn__q0exL {
    width: 100%;
    min-width: auto;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/assessment/CandidateWelcome.module.css"],"names":[],"mappings":"AAAA,gCAAQ,iBAAiB,EAAE,aAAa,EAAE,mBAAmB,EAAE,uBAAuB,EAAE,0BAA0B,EAAE,eAAe,EAAE;AACrI,gCAAQ,iBAAiB,EAAE,+BAA+B,EAAE,+BAA+B,EAAE,WAAW,EAAE,gBAAgB,EAAE,yBAAyB,EAAE,gBAAgB,EAAE;AACzK,kCAAU,sBAAsB,EAAE,sCAAsC,EAAE;AAC1E,mCAAW,aAAa,EAAE,mBAAmB,EAAE,YAAY,EAAE;AAC7D,oCAAY,WAAW,EAAE,YAAY,EAAE,cAAc,EAAE;AACvD,oCAAY,kBAAkB,EAAE,sBAAsB,EAAE,gBAAgB,EAAE;AAC1E,gCAAQ,eAAe,EAAE;AACzB,sCAAc,mBAAmB,EAAE;AACnC,iCAAS,iBAAiB,EAAE,mBAAmB,EAAE,qBAAqB,EAAE;AACxE,mCAAW,qBAAqB,EAAE,iBAAiB,EAAE,kBAAkB,EAAE,kBAAkB,EAAE,gBAAgB,EAAE,oBAAoB,EAAE;AACrI,oCAAY,mBAAmB,EAAE,YAAY,EAAE;AAC/C,oCAAY,mBAAmB,EAAE,YAAY,EAAE;AAC/C,oCAAY,mBAAmB,EAAE,YAAY,EAAE;AAC/C,kCAAS,kBAAkB,EAAE,sBAAsB,EAAE,gBAAgB,EAAE,sBAAsB,EAAE;AAC/F,uCAAe,aAAa,EAAE,8BAA8B,EAAE,SAAS,EAAE,sBAAsB,EAAE;AACjG,mCAAW,iBAAiB,EAAE,+BAA+B,EAAE,+BAA+B,EAAE,gBAAgB,EAAE,aAAa,EAAE,sBAAsB,EAAE,YAAY,EAAE,oBAAoB,EAAE;AAC7L,yCAAiB,0BAA0B,EAAE,0CAA0C,EAAE;AACzF,qCAAa,aAAa,EAAE,mBAAmB,EAAE,YAAY,EAAE;AAC/D,kCAAU,WAAW,EAAE,YAAY,EAAE,wBAAwB,EAAE,YAAY,EAAE,kBAAkB,EAAE,aAAa,EAAE,mBAAmB,EAAE,uBAAuB,EAAE,kBAAkB,EAAE,gBAAgB,EAAE,cAAc,EAAE;AACpN,qCAAY,kBAAkB,EAAE,gBAAgB,EAAE,yBAAyB,EAAE,sBAAsB,EAAE,sBAAsB,EAAE;AAC7H,sCAAc,aAAa,EAAE,sBAAsB,EAAE,WAAW,EAAE;AAClE,oCAAY,kBAAkB,EAAE,gBAAgB,EAAE,sBAAsB,EAAE;AAC1E,mCAAW,iBAAiB,EAAE,sBAAsB,EAAE,gBAAgB,EAAE;AACxE,oCAAY,kBAAkB,EAAE,mBAAmB,EAAE,gBAAgB,EAAE;AACvE,kCAAU,aAAa,EAAE,WAAW,EAAE,kBAAkB,EAAE,mBAAmB,EAAE,8BAA8B,EAAE,4BAA4B,EAAE,sBAAsB,EAAE;AACrK,sCAAc,iBAAiB,EAAE,cAAc,EAAE,eAAe,EAAE;AAClE,yCAAiB,aAAa,EAAE,sBAAsB,EAAE,YAAY,EAAE,WAAW,EAAE;AACnF,uCAAe,kBAAkB,EAAE,gBAAgB,EAAE,cAAc,EAAE;AACrE,sCAAc,kBAAkB,EAAE,cAAc,EAAE,gBAAgB,EAAE,gBAAgB,EAAE;AACtF,oCAAY,WAAW,EAAE,gBAAgB,EAAE,sBAAsB,EAAE,YAAY,EAAE,YAAY,EAAE,4BAA4B,EAAE,mBAAmB,EAAE,gBAAgB,EAAE,4BAA4B,EAAE;AAClM,0CAAkB,2BAA2B,EAAE;AAC/C,kCAAU,sBAAsB,EAAE,kBAAkB,EAAE,kBAAkB,EAAE,sBAAsB,EAAE,mCAAmC,EAAE;;AAEvI,sBAAsB;AACtB;EACE,gCAAQ,4BAA4B,EAAE;EACtC,uCAAe,0BAA0B,EAAE,YAAY,EAAE;EACzD,mCAAW,aAAa,EAAE;EAC1B,kCAAU,WAAW,EAAE,YAAY,EAAE,iBAAiB,EAAE;EACxD,oCAAY,iBAAiB,EAAE;EAC/B,mCAAW,kBAAkB,EAAE;AACjC;;AAEA;EACE,gCAAQ,qBAAqB,EAAE;EAC/B,iCAAS,iBAAiB,EAAE;EAC5B,kCAAS,kBAAkB,EAAE,mBAAmB,EAAE;EAClD,uCAAe,YAAY,EAAE;EAC7B,mCAAW,eAAe,EAAE;EAC5B,kCAAU,WAAW,EAAE,YAAY,EAAE,iBAAiB,EAAE;EACxD,qCAAY,iBAAiB,EAAE;EAC/B,oCAAY,kBAAkB,EAAE;EAChC,mCAAW,kBAAkB,EAAE;EAC/B,oCAAY,iBAAiB,EAAE;AACjC;;AAEA,iBAAiB;AACjB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,eAAe;EACf,mDAA2B;AAC7B;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,0CAA0C;EAC1C,oDAA4B;AAC9B;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,6BAA6B;EAC7B,sCAAsC;EACtC,uFAAuF;AACzF;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,eAAe;EACf,0BAA0B;EAC1B,4BAA4B;EAC5B,mCAAmC;AACrC;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,uBAAuB;EACvB,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mCAAmC;EACnC,aAAa;EACb,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;EACxB,2BAA2B;EAC3B,sBAAsB;EACtB,+BAA+B;EAC/B,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;EAC3B,6BAA6B;AAC/B;;AAEA;EACE,wBAAwB;EACxB,sBAAsB;EACtB,YAAY;EACZ,YAAY;EACZ,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;EAC3B,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,2BAA2B;EAC3B,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,uBAAuB;EACvB,YAAY;EACZ,YAAY;EACZ,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,wBAAwB;EACxB,YAAY;EACZ,eAAe;EACf,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,4BAA4B;EAC5B,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,4BAA4B;EAC5B,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,uBAAuB;IACvB,YAAY;EACd;;EAEA;IACE,gBAAgB;IAChB,YAAY;EACd;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;EACb;;EAEA;;IAEE,WAAW;IACX,oBAAoB;IACpB,iBAAiB;EACnB;AACF;;AAEA,oCAAoC;AACpC;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,2CAA2C;EAC3C,oDAA4B;AAC9B;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,gCAAgC;EAChC,6DAA6D;AAC/D;;AAEA;EACE,eAAe;EACf,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,gBAAgB;EAChB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,2BAA2B;EAC3B,4BAA4B;EAC5B,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,8BAA8B;EAC9B,4BAA4B;EAC5B,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mCAAmC;EACnC,aAAa;EACb,WAAW;EACX,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;EACjB,sBAAsB;EACtB,iCAAiC;EACjC,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,6BAA6B;AAC/B;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE;IACE,eAAe;IACf,4BAA4B;EAC9B;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,iBAAiB;IACjB,qBAAqB;EACvB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,WAAW;EACb;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,0BAA0B;IAC1B,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,uBAAuB;IACvB,kBAAkB;EACpB;;EAEA;IACE,qBAAqB;IACrB,sBAAsB;IACtB,WAAW;EACb;;EAEA;;IAEE,WAAW;IACX,eAAe;EACjB;AACF","sourcesContent":[".page { min-height: 100vh; display: flex; align-items: center; justify-content: center; background: var(--gray-50); padding: 1.5rem; }\n.card { background: white; border: 1px solid var(--border); border-radius: var(--radius-lg); width: 100%; max-width: 900px; box-shadow: var(--shadow); overflow: hidden; }\n.topBar { padding: 0.9rem 1.5rem; border-bottom: 1px solid var(--border); }\n.logoRow { display: flex; align-items: center; gap: 0.65rem; }\n.logoMark { width: 32px; height: auto; flex-shrink: 0; }\n.logoText { font-size: 0.75rem; color: var(--gray-700); font-weight: 500; }\n.body { padding: 1.5rem; }\n.greetBlock { margin-bottom: 1rem; }\n.greet { font-size: 1.4rem; color: var(--black); margin-bottom: 0.4rem; }\n.roleTag { display: inline-block; padding: 3px 10px; border-radius: 4px; font-size: 0.75rem; font-weight: 500; transition: all 0.2s; }\n.role_RSM { background: #1a5c38; color: white; }\n.role_FSM { background: #2d8659; color: white; }\n.role_TSE { background: #4da878; color: white; }\n.intro { font-size: 0.82rem; color: var(--gray-700); line-height: 1.6; margin-bottom: 1.25rem; }\n.sectionGrid { display: grid; grid-template-columns: 1fr 1fr; gap: 1rem; margin-bottom: 1.25rem; }\n.secCard { background: white; border: 1px solid var(--border); border-radius: var(--radius-lg); padding: 1.25rem; display: flex; flex-direction: column; gap: 0.85rem; transition: all 0.2s; }\n.secCard:hover { border-color: var(--green); box-shadow: 0 4px 12px rgba(26,92,56,0.08); }\n.secHeader { display: flex; align-items: center; gap: 0.75rem; }\n.secNum { width: 36px; height: 36px; background: var(--green); color: white; border-radius: 50%; display: flex; align-items: center; justify-content: center; font-size: 0.95rem; font-weight: 700; flex-shrink: 0; }\n.secLabel { font-size: 0.75rem; font-weight: 500; text-transform: uppercase; letter-spacing: 0.05em; color: var(--gray-500); }\n.secContent { display: flex; flex-direction: column; gap: 0.5rem; }\n.secTitle { font-size: 0.95rem; font-weight: 600; color: var(--gray-900); }\n.secDesc { font-size: 0.8rem; color: var(--gray-600); line-height: 1.5; }\n.secCount { font-size: 0.75rem; color: var(--green); font-weight: 500; }\n.notice { display: flex; gap: 0.6rem; padding: 1rem 1rem; background: #fff8f0; border-left: 4px solid #d35400; border-radius: var(--radius); margin-bottom: 1.25rem; }\n.noticeIcon { font-size: 1.1rem; flex-shrink: 0; margin-top: 2px; }\n.noticeContent { display: flex; flex-direction: column; gap: 0.35rem; width: 100%; }\n.noticeTitle { font-size: 0.85rem; font-weight: 700; color: #d35400; }\n.noticeText { font-size: 0.78rem; color: #c77a2e; line-height: 1.5; font-weight: 600; }\n.startBtn { width: 100%; padding: 0.75rem; background: var(--red); color: white; border: none; border-radius: var(--radius); font-size: 0.875rem; font-weight: 500; transition: background 0.15s; }\n.startBtn:hover { background: var(--red-dark); }\n.footer { padding: 0.9rem 1.5rem; text-align: center; font-size: 0.68rem; color: var(--gray-300); border-top: 1px solid var(--border); }\n\n/* Mobile Responsive */\n@media (max-width: 640px) {\n  .card { border-radius: var(--radius); }\n  .sectionGrid { grid-template-columns: 1fr; gap: 0.85rem; }\n  .secCard { padding: 1rem; }\n  .secNum { width: 32px; height: 32px; font-size: 0.9rem; }\n  .secTitle { font-size: 0.9rem; }\n  .secDesc { font-size: 0.75rem; }\n}\n\n@media (max-width: 480px) {\n  .body { padding: 1.25rem 1rem; }\n  .greet { font-size: 1.2rem; }\n  .intro { font-size: 0.78rem; margin-bottom: 1rem; }\n  .sectionGrid { gap: 0.75rem; }\n  .secCard { padding: 0.9rem; }\n  .secNum { width: 28px; height: 28px; font-size: 0.8rem; }\n  .secLabel { font-size: 0.7rem; }\n  .secTitle { font-size: 0.85rem; }\n  .secDesc { font-size: 0.72rem; }\n  .secCount { font-size: 0.7rem; }\n}\n\n/* Modal Styles */\n.modalOverlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.6);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  padding: 1.5rem;\n  animation: fadeIn 0.2s ease;\n}\n\n@keyframes fadeIn {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n.modalCard {\n  background: white;\n  border-radius: var(--radius-lg);\n  width: 100%;\n  max-width: 800px;\n  max-height: none;\n  overflow-y: visible;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);\n  animation: slideUp 0.3s ease;\n}\n\n@keyframes slideUp {\n  from {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.modalHeader {\n  padding: 1rem 1.25rem 0.75rem;\n  border-bottom: 1px solid var(--border);\n  background: linear-gradient(135deg, var(--red-light) 0%, rgba(255, 230, 225, 0.5) 100%);\n}\n\n.modalTitle {\n  font-size: 1rem;\n  font-weight: 700;\n  color: var(--red);\n  margin-bottom: 0.25rem;\n}\n\n.modalSub {\n  font-size: 0.72rem;\n  color: var(--gray-600);\n}\n\n.modalContent {\n  padding: 0.85rem 1rem;\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n}\n\n.modalSection {\n  display: flex;\n  gap: 0.75rem;\n  padding: 0.8rem;\n  background: var(--gray-50);\n  border-radius: var(--radius);\n  border-left: 3px solid var(--green);\n}\n\n.modalSectionIcon {\n  font-size: 1.25rem;\n  flex-shrink: 0;\n  min-width: 28px;\n  text-align: center;\n}\n\n.modalSectionTitle {\n  font-size: 0.8rem;\n  font-weight: 700;\n  color: var(--gray-900);\n  margin-bottom: 0.25rem;\n}\n\n.modalSectionText {\n  font-size: 0.73rem;\n  color: var(--gray-700);\n  line-height: 1.4;\n}\n\n.restrictionsList {\n  display: flex;\n  flex-direction: column;\n  gap: 0.4rem;\n  margin-top: 0.3rem;\n}\n\n.restrictionItem {\n  display: flex;\n  gap: 0.5rem;\n  align-items: flex-start;\n  font-size: 0.72rem;\n  color: var(--gray-700);\n  line-height: 1.3;\n}\n\n.restrictionBullet {\n  color: var(--red);\n  font-weight: 700;\n  flex-shrink: 0;\n  font-size: 0.55rem;\n  margin-top: 0.15rem;\n}\n\n.modalActions {\n  padding: 0.85rem 1rem;\n  border-top: 1px solid var(--border);\n  display: flex;\n  gap: 0.6rem;\n  justify-content: flex-end;\n}\n\n.cancelBtn {\n  padding: 0.55rem 1.25rem;\n  background: var(--gray-100);\n  color: var(--gray-700);\n  border: 1px solid var(--border);\n  border-radius: var(--radius);\n  font-size: 0.75rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.cancelBtn:hover {\n  background: var(--gray-200);\n  border-color: var(--gray-300);\n}\n\n.confirmBtn {\n  padding: 0.55rem 1.25rem;\n  background: var(--red);\n  color: white;\n  border: none;\n  border-radius: var(--radius);\n  font-size: 0.75rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.confirmBtn:hover:not(:disabled) {\n  background: var(--red-dark);\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(220, 38, 38, 0.3);\n}\n\n.confirmBtn:disabled {\n  background: var(--gray-300);\n  color: var(--gray-500);\n  cursor: not-allowed;\n  opacity: 0.6;\n}\n\n.cameraRequestBtn {\n  width: 100%;\n  padding: 0.55rem 1rem;\n  background: var(--blue);\n  color: white;\n  border: none;\n  border-radius: var(--radius);\n  font-size: 0.75rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s;\n  margin-top: 0.5rem;\n}\n\n.cameraRequestBtn:hover:not(:disabled) {\n  background: var(--blue-dark);\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(37, 99, 235, 0.3);\n}\n\n.cameraRequestBtn:disabled {\n  background: var(--green);\n  color: white;\n  cursor: default;\n  opacity: 0.8;\n}\n\n.cameraSuccessBox {\n  padding: 0.6rem 0.85rem;\n  background: #f0fdf4;\n  border: 1px solid #86efac;\n  border-radius: var(--radius);\n  color: #166534;\n  font-size: 0.72rem;\n  font-weight: 600;\n  display: flex;\n  align-items: center;\n  margin-bottom: 0.5rem;\n  gap: 0.5rem;\n}\n\n.cameraErrorBox {\n  padding: 0.6rem 0.85rem;\n  background: #fef2f2;\n  border: 1px solid #fecaca;\n  border-radius: var(--radius);\n  color: #991b1b;\n  font-size: 0.72rem;\n  font-weight: 600;\n}\n\n@media (max-width: 640px) {\n  .modalOverlay {\n    padding: 1rem;\n  }\n\n  .modalCard {\n    max-width: 100%;\n    max-height: none;\n  }\n\n  .modalHeader {\n    padding: 0.9rem 1rem 0.7rem;\n  }\n\n  .modalTitle {\n    font-size: 0.95rem;\n  }\n\n  .modalContent {\n    padding: 0.75rem 0.9rem;\n    gap: 0.65rem;\n  }\n\n  .modalSection {\n    padding: 0.75rem;\n    gap: 0.65rem;\n  }\n\n  .modalSectionIcon {\n    font-size: 1.1rem;\n    min-width: 24px;\n  }\n\n  .modalSectionTitle {\n    font-size: 0.75rem;\n    margin-bottom: 0.2rem;\n  }\n\n  .modalSectionText {\n    font-size: 0.68rem;\n    line-height: 1.3;\n  }\n\n  .restrictionsList {\n    gap: 0.35rem;\n    margin-top: 0.25rem;\n  }\n\n  .restrictionItem {\n    font-size: 0.68rem;\n    gap: 0.45rem;\n    line-height: 1.2;\n  }\n\n  .modalActions {\n    padding: 0.75rem 0.9rem;\n    flex-direction: row;\n    gap: 0.5rem;\n  }\n\n  .cancelBtn,\n  .confirmBtn {\n    width: auto;\n    padding: 0.5rem 1rem;\n    font-size: 0.7rem;\n  }\n}\n\n/* Proctoring Warning Modal Styles */\n.proctoringWarningCard {\n  background: white;\n  border-radius: var(--radius-lg);\n  width: 100%;\n  max-width: 500px;\n  max-height: none;\n  overflow-y: visible;\n  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.35);\n  animation: slideUp 0.3s ease;\n}\n\n.proctoringHeader {\n  padding: 1rem 1.25rem 0.75rem;\n  text-align: center;\n  border-bottom: 2px solid #fee2e2;\n  background: linear-gradient(135deg, #fef2f2 0%, #fff7f7 100%);\n}\n\n.proctoringIcon {\n  font-size: 2rem;\n  display: block;\n  margin-bottom: 0.25rem;\n}\n\n.proctoringTitle {\n  font-size: 1.1rem;\n  font-weight: 800;\n  color: #dc2626;\n  margin: 0;\n  letter-spacing: -0.5px;\n}\n\n.proctoringContent {\n  padding: 1rem;\n  display: flex;\n  flex-direction: column;\n  gap: 0.85rem;\n}\n\n.proctoringIntro {\n  font-size: 0.8rem;\n  color: var(--gray-700);\n  line-height: 1.5;\n  margin: 0;\n  font-weight: 500;\n}\n\n.proctoringWarnings {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 0.65rem;\n}\n\n.warningCard {\n  display: flex;\n  flex-direction: column;\n  gap: 0.35rem;\n  padding: 0.75rem;\n  background: #fafafa;\n  border: 1.5px solid #f3f4f6;\n  border-radius: var(--radius);\n  transition: all 0.2s ease;\n  text-align: center;\n}\n\n.warningCard:hover {\n  border-color: #dc2626;\n  background: #fff5f5;\n  box-shadow: 0 2px 8px rgba(220, 38, 38, 0.1);\n}\n\n.warningIcon {\n  font-size: 1.4rem;\n  display: block;\n}\n\n.warningText {\n  display: flex;\n  flex-direction: column;\n  gap: 0.2rem;\n}\n\n.warningText strong {\n  font-size: 0.78rem;\n  font-weight: 700;\n  color: #1f2937;\n  display: block;\n}\n\n.warningText p {\n  font-size: 0.7rem;\n  color: var(--gray-600);\n  line-height: 1.3;\n  margin: 0;\n}\n\n.proctoringAcknowledgment {\n  padding: 0.75rem 0.9rem;\n  background: #fef3c7;\n  border-left: 3px solid #f59e0b;\n  border-radius: var(--radius);\n  font-size: 0.75rem;\n  color: #78350f;\n  line-height: 1.4;\n  text-align: center;\n  font-weight: 600;\n}\n\n.proctoringActions {\n  padding: 0.9rem 1rem;\n  border-top: 1px solid var(--border);\n  display: flex;\n  gap: 0.6rem;\n  justify-content: center;\n  background: var(--gray-50);\n}\n\n.backBtn {\n  padding: 0.6rem 1.25rem;\n  background: white;\n  color: var(--gray-700);\n  border: 2px solid var(--gray-300);\n  border-radius: var(--radius);\n  font-size: 0.78rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s;\n  min-width: 110px;\n}\n\n.backBtn:hover {\n  background: var(--gray-100);\n  border-color: var(--gray-400);\n}\n\n.proceedBtn {\n  padding: 0.6rem 1.25rem;\n  background: #dc2626;\n  color: white;\n  border: none;\n  border-radius: var(--radius);\n  font-size: 0.78rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s;\n  min-width: 110px;\n}\n\n.proceedBtn:hover {\n  background: #b91c1c;\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(220, 38, 38, 0.25);\n}\n\n.proceedBtn:active {\n  transform: translateY(0);\n}\n\n@media (max-width: 640px) {\n  .proctoringWarningCard {\n    max-width: 100%;\n    border-radius: var(--radius);\n  }\n\n  .proctoringHeader {\n    padding: 1rem 1.25rem 0.85rem;\n  }\n\n  .proctoringIcon {\n    font-size: 1.8rem;\n    margin-bottom: 0.3rem;\n  }\n\n  .proctoringTitle {\n    font-size: 1rem;\n  }\n\n  .proctoringContent {\n    padding: 1rem;\n    gap: 0.9rem;\n  }\n\n  .proctoringIntro {\n    font-size: 0.8rem;\n  }\n\n  .proctoringWarnings {\n    grid-template-columns: 1fr;\n    gap: 0.75rem;\n  }\n\n  .warningCard {\n    padding: 0.8rem;\n  }\n\n  .warningIcon {\n    font-size: 1.4rem;\n  }\n\n  .warningText strong {\n    font-size: 0.78rem;\n  }\n\n  .warningText p {\n    font-size: 0.7rem;\n  }\n\n  .proctoringAcknowledgment {\n    padding: 0.75rem 0.9rem;\n    font-size: 0.75rem;\n  }\n\n  .proctoringActions {\n    padding: 0.85rem 1rem;\n    flex-direction: column;\n    gap: 0.6rem;\n  }\n\n  .backBtn,\n  .proceedBtn {\n    width: 100%;\n    min-width: auto;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"page": `CandidateWelcome_page__DuVVM`,
	"card": `CandidateWelcome_card__JdY17`,
	"topBar": `CandidateWelcome_topBar__PucjB`,
	"logoRow": `CandidateWelcome_logoRow__r1nb8`,
	"logoMark": `CandidateWelcome_logoMark__ZmeFm`,
	"logoText": `CandidateWelcome_logoText__vLUpM`,
	"body": `CandidateWelcome_body__gpEsF`,
	"greetBlock": `CandidateWelcome_greetBlock__v4DLT`,
	"greet": `CandidateWelcome_greet__MQzTd`,
	"roleTag": `CandidateWelcome_roleTag__3Itaj`,
	"role_RSM": `CandidateWelcome_role_RSM__Ps41s`,
	"role_FSM": `CandidateWelcome_role_FSM__aknPH`,
	"role_TSE": `CandidateWelcome_role_TSE__cJUJR`,
	"intro": `CandidateWelcome_intro__xpn+q`,
	"sectionGrid": `CandidateWelcome_sectionGrid__6FqJd`,
	"secCard": `CandidateWelcome_secCard__MrWn7`,
	"secHeader": `CandidateWelcome_secHeader__9nLFf`,
	"secNum": `CandidateWelcome_secNum__9VmVZ`,
	"secLabel": `CandidateWelcome_secLabel__JA1P+`,
	"secContent": `CandidateWelcome_secContent__3sSLD`,
	"secTitle": `CandidateWelcome_secTitle__qtl2f`,
	"secDesc": `CandidateWelcome_secDesc__31mTc`,
	"secCount": `CandidateWelcome_secCount__BBWyC`,
	"notice": `CandidateWelcome_notice__xyfk2`,
	"noticeIcon": `CandidateWelcome_noticeIcon__uvF2y`,
	"noticeContent": `CandidateWelcome_noticeContent__tihJc`,
	"noticeTitle": `CandidateWelcome_noticeTitle__WtOR-`,
	"noticeText": `CandidateWelcome_noticeText__AltyL`,
	"startBtn": `CandidateWelcome_startBtn__VR0Kj`,
	"footer": `CandidateWelcome_footer__LR9GM`,
	"modalOverlay": `CandidateWelcome_modalOverlay__5Foaa`,
	"fadeIn": `CandidateWelcome_fadeIn__BLaKZ`,
	"modalCard": `CandidateWelcome_modalCard__i+qm8`,
	"slideUp": `CandidateWelcome_slideUp__YLDSy`,
	"modalHeader": `CandidateWelcome_modalHeader__TEhus`,
	"modalTitle": `CandidateWelcome_modalTitle__vZXSW`,
	"modalSub": `CandidateWelcome_modalSub__IJrcT`,
	"modalContent": `CandidateWelcome_modalContent__w-Go2`,
	"modalSection": `CandidateWelcome_modalSection__ZRZWv`,
	"modalSectionIcon": `CandidateWelcome_modalSectionIcon__JGZru`,
	"modalSectionTitle": `CandidateWelcome_modalSectionTitle__Bon-P`,
	"modalSectionText": `CandidateWelcome_modalSectionText__56jQa`,
	"restrictionsList": `CandidateWelcome_restrictionsList__R7Wbu`,
	"restrictionItem": `CandidateWelcome_restrictionItem__9+hfD`,
	"restrictionBullet": `CandidateWelcome_restrictionBullet__9Srhy`,
	"modalActions": `CandidateWelcome_modalActions__A+kI0`,
	"cancelBtn": `CandidateWelcome_cancelBtn__A5sVY`,
	"confirmBtn": `CandidateWelcome_confirmBtn__c1qsd`,
	"cameraRequestBtn": `CandidateWelcome_cameraRequestBtn__53+gO`,
	"cameraSuccessBox": `CandidateWelcome_cameraSuccessBox__lW23s`,
	"cameraErrorBox": `CandidateWelcome_cameraErrorBox__DMB-W`,
	"proctoringWarningCard": `CandidateWelcome_proctoringWarningCard__danRi`,
	"proctoringHeader": `CandidateWelcome_proctoringHeader__sv105`,
	"proctoringIcon": `CandidateWelcome_proctoringIcon__oBHKX`,
	"proctoringTitle": `CandidateWelcome_proctoringTitle__8BOsU`,
	"proctoringContent": `CandidateWelcome_proctoringContent__0UkTg`,
	"proctoringIntro": `CandidateWelcome_proctoringIntro__J9eAG`,
	"proctoringWarnings": `CandidateWelcome_proctoringWarnings__X6gNA`,
	"warningCard": `CandidateWelcome_warningCard__DVIGN`,
	"warningIcon": `CandidateWelcome_warningIcon__ZkSuX`,
	"warningText": `CandidateWelcome_warningText__C9TXg`,
	"proctoringAcknowledgment": `CandidateWelcome_proctoringAcknowledgment__E+LGV`,
	"proctoringActions": `CandidateWelcome_proctoringActions__SRJdK`,
	"backBtn": `CandidateWelcome_backBtn__CwGuK`,
	"proceedBtn": `CandidateWelcome_proceedBtn__q0exL`
};
export default ___CSS_LOADER_EXPORT___;
